import styled from "styled-components";

export const StyledButton = styled.button`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  outline: 0;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #264445;
  text-transform: capitalize;
  transition: 0.3s;
  background: #ffdb00;
  border-radius: 28px;
  :hover {
    background-color: #ffffff;
    color: #000000;
    border: 1px solid #000000;
  }
`;
